/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-05-23 15:32:28
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-07-15 17:48:26
 * @FilePath: \MPC-monorepo\features\mpc-common\src\components\ProTablePlusForm\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  useState,
  useRef,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useMemo,
} from 'react';
import { ProTablePlus } from '@bedrock/eed-react';
import { useMemoizedFn, useControllableValue, useDebounceFn } from 'ahooks';
import { isEqual } from 'lodash';
import { useAddGroupTableData } from './addGroupTable';
import type { AddGroupFormColumn } from './addGroupTable';
import cx from 'classnames';
import './index.less';
import './QuoteTableExtend';

export type ProTablePlusFormProps = Omit<
  React.ComponentProps<typeof ProTablePlus>,
  'data' | 'columns'
> & {
  columns: AddGroupFormColumn[];
  value: any[];
  onChange: (value: any[]) => void;
  onBatchEditChange: (newData: any[]) => void;
  readOnly?: boolean;
};

type ProTablePlusFormRef = React.RefAttributes<typeof ProTablePlus> & {
  validateFields: () => Promise<any>;
  treeInitData: (data: any[], columns: any[]) => void;
  treeUpdateTableData: (data: any[], columns: any[], rowKey: string) => void;
  treeSetRowById: (id: string, row: any) => void;
  treeAddToParent: (id: string, row: any) => void;
  treeCopyRowById: (id: string, row: any) => void;
  treeDeleteRowById: (id: string) => void;
  treeDeleteRowByIds: (id: string[]) => void;
  getIsVirtualScroll: () => boolean;
};
export const ProTablePlusForm = forwardRef<
  ProTablePlusFormRef,
  ProTablePlusFormProps
>((props, ref) => {
  const [data, setData] = useControllableValue(props, {});
  const {
    value,
    onChange,
    onDataChange,
    columns,
    onBatchEditChange,
    readOnly = false,
    ...rest
  } = props;
  const tableRef = useRef(null);
  const [showData, setShowData] = useState(data);
  const [hasValidate, setHasValidate] = useState(false);
  const localData = useRef(data);

  const setLocalData = useMemoizedFn((newData) => {
    if (isEqual(localData.current, newData)) return;
    localData.current = newData;
    setShowData(newData);
    setData(newData);
  });

  const {
    treeReady,
    isTree,
    columns: addGroupColumns,
    treeSetRowById,
    treeAddToParent,
    treeCopyRowById,
    treeDeleteRowById,
    treeDeleteRowByIds,
    treeUpdateTableData,
    treeInitData,
  } = useAddGroupTableData(
    showData,
    setLocalData,
    columns,
    readOnly
  );

  const isVirtualScroll = useMemo(() => {
    return rest?.virtual?.maxRows && showData?.length > rest?.virtual?.maxRows;
  }, [rest?.virtual?.maxRows, showData]);

  const scrollTop = useRef(0);

  const validateFields = useMemoizedFn(() => {
    return new Promise((resolve, reject) => {
      setHasValidate(true);
      tableRef.current.validate().then((err, values) => {
        if (err?.length) {
          reject(err);
        } else {
          resolve(values);
        }
      });
    });
  });

  // 虚拟滚动场景下需要根据
  const allValidate = useMemoizedFn(() => {
    // 判断是否触发虚拟滚动
    if (!isVirtualScroll) {
      return tableRef.current.validate();
    }
    const vMap = tableRef.current.getValidateRulesMap('all') as Map<string, any[]>;
    return Promise.all(Array.from(vMap.values()).map((v: any) =>{
      return new Promise((resolve, reject) => {
        v?.doValidate?.().then(n => {
          resolve(n);
        })
      })
    })).then(n => n.filter(v => !!v));
  })

  const validateFieldsAndScroll = useMemoizedFn(() => {
    return new Promise((resolve, reject) => {
      setHasValidate(true);
      allValidate().then((err, values) => {
        if (err?.length) {
          reject(err);
          console.log('err', err);
          tableRef.current.scrollTo({
            key: err[0].rowKey,
            dataIndex: err[0].dataIndex,
          })
          setTimeout(() => {
            tableRef.current.validate()
          }, 10);
        } else {
          resolve(values);
        }
      });
    });
  });

  // 防抖validate
  const { run: debounceValidate } = useDebounceFn(() => {
    tableRef?.current?.validate?.()
  }, {
    wait: 40,
    leading: false,
    trailing: true,
  });

  const tempOnScroll = useMemoizedFn((e) => {
    rest?.onScroll?.(e);
    // 判断只有垂直滚动时才进行校验
    if (hasValidate && isVirtualScroll) {
      debounceValidate()
    }
  })

  const getIsVirtualScroll = useMemoizedFn(() => {
    return isVirtualScroll;
  })

  useImperativeHandle(ref, () => {
    if (tableRef?.current?.validate) {
      return {
        ...tableRef.current,
        validateFields,
        validateFieldsAndScroll,
        treeInitData,
        treeUpdateTableData,
        treeSetRowById,
        treeAddToParent,
        treeCopyRowById,
        treeDeleteRowById,
        treeDeleteRowByIds,
        getIsVirtualScroll,
      };
    }
    return {};
  });

  useEffect(() => {
    // 非树形数据同步
    if (!isTree) {
      if (!isEqual(data, tableRef.current.getData())) {
        setLocalData(data);
      }
    }
  }, [data, isTree]);

  const onDataChangeTemp = useMemoizedFn((newData, changeData) => {
    onDataChange?.(newData, changeData);

    // 非树形数据同步
    if (!isTree) {
      if (!isEqual(newData, data)) {
        setData(newData);
      }
    }
  });

  const onBatchEditChangeTemp = useMemoizedFn((newData) => {
    onBatchEditChange?.(newData);
    if (isTree) {
      treeInitData(tableRef.current.getData(), columns);
    }
  });
  return treeReady && <ProTablePlus
      ref={tableRef}
      data={showData}
      onDataChange={onDataChangeTemp}
      columns={addGroupColumns}
      onBatchEditChange={onBatchEditChangeTemp}
      emptyText={<div style={{ textAlign: 'center', color: '#878A99' }}>暂无数据</div>}
      {...rest}
      containerClassName={cx("pro-table-form", rest?.containerClassName)}
      onScroll={tempOnScroll}
    />;
});
